(() => {
const $848f49749bdff7fd$export$e1252723db1c541 = {
    externalVideoContainer: '.video--external',
    internalVideoContainer: '.video--internal',
    videoElement: 'video'
};
const $848f49749bdff7fd$export$ce4ab0c55987d1ff = {
    muted: 'video__audio-trigger--muted',
    videoBlocked: 'blocked'
};
const $848f49749bdff7fd$var$trackYoutubeIframe = ()=>{
    // To track user behavior, the iframe API must be included.
    const src = 'https://www.youtube.com/iframe_api';
    // check if already loaded
    if (!document.querySelector(`script[src="${src}"]`)) {
        const script = document.createElement('script');
        script.src = src;
        document.head.appendChild(script);
    }
};
const $848f49749bdff7fd$export$ce84bb03b7c3c023 = (video)=>{
    return video.mozHasAudio || Boolean(video.webkitAudioDecodedByteCount) || Boolean(video.audioTracks && video.audioTracks.length);
};
const $848f49749bdff7fd$export$58ce55ca15086934 = (el)=>{
    const container = el.querySelector('.youtube');
    let src = container.getAttribute('data-src');
    if (src) {
        // remove blocked class
        el.classList.remove($848f49749bdff7fd$export$ce4ab0c55987d1ff.videoBlocked);
        // Update src to autoplay
        //! Important: mute=1 is necessary to autoplay the video
        src = src.replace('autoplay=0', 'autoplay=1');
        src = src.replace('mute=0', 'mute=1');
        // Create iframe
        const iframe = `<iframe src="${src}" frameborder="0" allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
        container.innerHTML = iframe;
        // Track iframe
        $848f49749bdff7fd$var$trackYoutubeIframe();
    }
};


window.addEventListener('load', ()=>{
    // Handle internal videos.
    document.querySelectorAll((0, $848f49749bdff7fd$export$e1252723db1c541).internalVideoContainer).forEach((el)=>{
        $0e7b8536988b9644$var$displayAudioTrigger(el.querySelector((0, $848f49749bdff7fd$export$e1252723db1c541).videoElement));
    });
    // Handle external videos.
    document.querySelectorAll((0, $848f49749bdff7fd$export$e1252723db1c541).externalVideoContainer).forEach((el)=>{
        el.addEventListener('click', ()=>{
            if (el.classList.contains((0, $848f49749bdff7fd$export$ce4ab0c55987d1ff).videoBlocked)) (0, $848f49749bdff7fd$export$58ce55ca15086934)(el);
        });
    });
});
const $0e7b8536988b9644$var$displayAudioTrigger = (video)=>{
    if (!video.hasAttribute('controls') && (0, $848f49749bdff7fd$export$ce84bb03b7c3c023)(video)) {
        const audioTrigger = document.createElement('div');
        audioTrigger.classList.add('video__audio-trigger', (0, $848f49749bdff7fd$export$ce4ab0c55987d1ff).muted);
        video.parentNode.appendChild(audioTrigger);
        audioTrigger.addEventListener('click', ()=>{
            video.muted = !video.muted;
            audioTrigger.classList.toggle((0, $848f49749bdff7fd$export$ce4ab0c55987d1ff).muted);
        });
    }
};
// Listen for color scheme changes
document.addEventListener('colorModeChange', (e)=>{
    document.querySelectorAll((0, $848f49749bdff7fd$export$e1252723db1c541).videoConsent).forEach((el)=>{
        el.setAttribute('data-color-scheme', e.detail);
    });
});

})();
//# sourceMappingURL=video.min.js.map
